import React, { useEffect } from 'react'
import TicketDetails from '../../Common/TicketDetails'
import { CheckINOutAttendee } from 'types/event/eventAttendance'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { Avatar, Dropdown, Form } from 'antd'
import { convertToUtc, getNameSignature } from 'helper/utility'
import { DotsThree, PencilSimple } from '@phosphor-icons/react'
import { useGetDropInAttendeeDetails } from 'api/Event/Dropin'
import { useParams } from 'react-router-dom'
import Spinner from 'components/Spinner'
import { Person } from 'types/globalTypes'
import FindAccount from './FindAccount'
import { eventDetailsStore } from 'state/event/eventDetails'
import { EventResp } from 'types/event/events'

const DropOutTab: React.FC = () => {
  const [form] = Form.useForm()
  const { id }: { id: string } = useParams()
  const {
    participantData,
    setAddDropInAttendeeModalOpen,
    setDropInAttendeeData,
    setDropInPricing,
  }: {
    participantData: CheckINOutAttendee | null
    setAddDropInAttendeeModalOpen: (state: boolean) => void
    setDropInAttendeeData: (
      state: Person & { type: 'kid' | 'authorizedAdult' | 'guardian' },
    ) => void
    setDropInPricing: (state: number) => void
  } = eventAttendanceStore(store => ({
    participantData: store.participantData,
    setAddDropInAttendeeModalOpen: store.setAddDropInAttendeeModalOpen,
    setDropInAttendeeData: store.setDropInAttendeeData,
    setDropInPricing: store.setDropInPricing,
  }))
  const eventDetails: EventResp = eventDetailsStore(
    store => store.eventDetailedData,
  )
  const params = {
    eventId: eventDetails?._id,
    memberId: participantData._id,
    date: convertToUtc(new Date()),
    checkInId: participantData.checkInId,
  }

  const {
    data: dropInAttendeeDetail,
    isLoading: isDropInAttendeeDetailLoading,
    isFetching: isDropInAttendeeDetailFetching,
    refetch: refetchDropInAttendeeDetail,
  } = useGetDropInAttendeeDetails(params)
  const handleEditParticipant = () => {
    setDropInAttendeeData(
      dropInAttendeeDetail.checkIns[0].dropInAttendee || participantData._id,
    )
    setAddDropInAttendeeModalOpen(true)
  }

  const items = [
    {
      key: 'edit',
      label: (
        <div
          className="flex align-center gap-10px"
          onClick={handleEditParticipant}
        >
          <PencilSimple size={20} color="#000" />
          <p className="text-black">Edit</p>
        </div>
      ),
    },
  ]

  useEffect(() => {
    refetchDropInAttendeeDetail()
  }, [id])

  useEffect(() => {
    if (dropInAttendeeDetail) {
      setDropInPricing(dropInAttendeeDetail.cost?.amount)
    }
  }, [dropInAttendeeDetail])

  return (
    <div className="flex gap-20px">
      {isDropInAttendeeDetailLoading || isDropInAttendeeDetailFetching ? (
        <div className="flex justify-center align-center py-40px w-full">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="flex-1 relative" style={{ minHeight: '35rem' }}>
            <div className="mt-20px bg-greyLight px-20px py-15px flex gap-20px align-center justify-between radius-6">
              <div className=" flex gap-16px align-center">
                <Avatar size={32} src={participantData.photo?.post}>
                  {getNameSignature(
                    `${participantData.firstName} ${participantData.lastName}`,
                  )}
                </Avatar>
                <h3>{`${participantData.firstName} ${participantData.lastName}`}</h3>
              </div>
              <Dropdown trigger={['click']} menu={{ items }}>
                <DotsThree className="pointer" size={20} color="#000" />
              </Dropdown>
            </div>

            <div>
              <FindAccount />
            </div>
          </div>

          <div className="bg-dark-gray px-30px py-20px">
            <TicketDetails ticketDetails={dropInAttendeeDetail.cost} />
          </div>
        </>
      )}
    </div>
  )
}

export default DropOutTab
